(function() {
    'use strict';

    var readyDef;

    function onYouTubeIframeAPIReady() {
        if (!readyDef) {
            readyDef = $.Deferred();
        }

        readyDef.resolve();
    }

    function initYoutubeApi() {
        if (!readyDef) {
            var tag = document.createElement('script');
            tag.id = 'iframe-youtube-api';
            tag.src = 'https://www.youtube.com/iframe_api';
            tag.async = true;

            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            readyDef = $.Deferred();
        }

        return readyDef.promise();
    }

    // Global YouTube-namespaced method that gets called when the API has loaded
    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

    window.hpYoutube = $.extend(window.hpYoutube || {}, {
        apiReady: initYoutubeApi
    });
}) ();
